import Button from 'components/base/Button';
import AvatarUpload from 'components/common/AvatarUpload';
import avatar from 'assets/img/team/150x150/avatar.webp';
import { Col, FloatingLabel, Form, Row, Tab, Tabs, Toast, ToastContainer } from 'react-bootstrap';
import ContactInformationForm from './components/ContactInformationForm';
import { useAuth } from 'providers/AuthProvider'
import { useState, useEffect, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import Conversactions from './components/Conversactions';

const UpdateContactTH = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth();

    const queryParams = new URLSearchParams(location.search);
    const contact_id = queryParams.get('contact_id');

    // State to store the form data from all child components
    const [formData, setFormData] = useState<any>({ 'contactForm': '', 'notes': '', 'image': null });
    // State to store existing contact data before update
    const [initialContactData, setInitialContactData] = useState<any>(null);
    const [contactImage, setContactImage] = useState(avatar);

    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const onChangeContactImage = (image: File | null) => {
        if (image) {
            setFormData({ ...formData, ['image']: image });
        }
    };

    // Function to handle input changes
    const handleNotesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Function to handle form data update from child components
    const updateFormData = (name: string, data: any) => {
        setFormData({ ...formData, [name]: data });
    };

    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = new FormData();
        form.append('contactForm', JSON.stringify(formData['contactForm']));
        form.append('notes', formData['notes']);
        form.append('file', formData['image']);

        try {
            const response = await apiClient.put(
                `/v1/contacts/${contact_id}`, form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    const fetchContact = async () => {
        //console.log("Get contact info: " + contact_id);
        try {
            const response = await apiClient.get(
                `/v1/contacts/${contact_id}`,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            const obj = {
                'name': response.data['name'], 'title': response.data['title'], 'phone': response.data['phone'],
                'email': response.data['email'], 'role': response.data['role'],
                'company_name': response.data['company_name'], 'picture_url': response.data['picture_url'],
                'inserted_at': response.data['inserted_at'],
            };

            setInitialContactData(obj);
            formData.contactForm = obj;
            formData.notes = response.data['notes'];

            if (response.data['picture'] !== undefined)
                setContactImage(`data:image/jpeg;base64, ${response.data['picture']}`);
            else
                setContactImage(avatar);

        } catch (error) {
            console.error('Error fetching contact data:', error);
        }
    };

    useEffect(() => {
        fetchContact();
    }, []);


    return (
        <div>
            <div>
                <ToastContainer className="p-3" position='top-center'>
                    <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                        <Toast.Body className=''>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>
            {initialContactData &&

                <div className="border-bottom mb-4 mx-n3 px-2 mx-lg-n6 px-lg-6">
                    <Row>
                        <Col xl={12}>
                            <div className="d-sm-flex justify-content-between">
                                <h2 className="mb-4">{initialContactData && initialContactData['name']}</h2>
                                <div className="d-flex mb-3">
                                    <Button variant="phoenix-primary" className="me-2 px-6" onClick={() => navigate(-1)} >
                                        Back
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Tabs
                            defaultActiveKey="personal_info"
                            id="uncontrolled-tab-example"
                            className="mb-3 nav-underline"
                        //onSelect={handleChangeTab}
                        >
                            <Tab eventKey="personal_info" title="Personal info">
                                <Form onSubmit={handleSumbit}>
                                    <Row>
                                        <Col sm={3} md={3} >
                                            <div className="d-flex align-items-end position-relative mb-3">
                                                <AvatarUpload src={formData['image'] ? formData['image'] : contactImage} size="5xl" onChange={onChangeContactImage} />
                                            </div>
                                        </Col>
                                        <Col sm={9} md={9} >
                                            <ContactInformationForm initialContactData={initialContactData} onUpdate={data => updateFormData('contactForm', data)} className="mb-6" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <h4 className="mb-3">Notes about contact</h4>
                                            <FloatingLabel
                                                controlId="contact-description"
                                                label="Contact notes">
                                                <Form.Control
                                                    as="textarea"
                                                    style={{ height: '128px' }}
                                                    type="text"
                                                    placeholder="Contact notes"
                                                    name='notes' value={formData.notes} onChange={handleNotesInputChange} />
                                            </FloatingLabel>
                                            <div className="text-end">
                                                <Button type="submit" variant="primary" className='mt-2'>Save contact</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Tab>
                            <Tab eventKey="view_sessions" title="Conversactions">
                                {contact_id && <Conversactions contactId={contact_id} />}
                            </Tab>
                        </Tabs>
                    </Row>
                </div>


            }
        </div>
    );
};

export default UpdateContactTH;
